import {BaseContainerModel} from '../../base-container.model';
import {
  bl_cms_event_attachment_RowClass,
} from '../../../dbschema';

export class CmsEventAttachmentContainerModel extends BaseContainerModel {
  bl_cms_event_attachment: bl_cms_event_attachment_RowClass = new bl_cms_event_attachment_RowClass();
}